import api from './api';

/**
 * Generate report (Word document + chart)
 * @param {string} customerId - Customer ID
 * @param {object} context - Report context data
 * @param {array} processes - Process list
 * @param {string} chartBase64 - Base64 encoded PNG chart (generated in frontend)
 */
export async function generateReport(customerId, context, processes, chartBase64) {
  // Fetch the template file from public folder
  const templateResponse = await fetch('/Template.docx');
  const templateBlob = await templateResponse.blob();

  // Convert to base64 for JSON transmission
  const templateBase64 = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1]; // Remove data URL prefix
      resolve(base64String);
    };
    reader.readAsDataURL(templateBlob);
  });

  const response = await api.post('/api/report/generate', {
    customerId,
    context,
    processes,
    template: templateBase64,
    chart: chartBase64  // Chart generated in frontend
  });

  return response.data;
}

/**
 * Generate standalone ROI table (with merged cells using docx library)
 * @param {string} customerId - Customer ID
 * @param {object} context - Report context data (for cost_per_agent)
 * @param {array} processes - Process list with ROI data
 */
export async function generateROITable(customerId, context, processes) {
  const response = await api.post('/api/report/generate-roi-table', {
    customerId,
    context,
    processes
  });

  return response.data;
}

/**
 * Download file from URL
 */
export function downloadFile(url, filename) {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
